import axios from "@/api/axiosInstance";
import { ExportMPDashboardCsvRequest } from "./types";

export const exportMPDashboardCsv = async (
  requestData: ExportMPDashboardCsvRequest,
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    `/api/private/stochastic/market-presence-dashboard/export/csv`,
    {
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
      params: requestData,
    },
  );

  return response.data;
};
